import { createFileRoute } from '@tanstack/react-router'
import { Site } from 'pages/site/Site'
import { z } from 'zod'

const parseParams = z.object({
  orgID: z.string(),
})

const searchParams = z.object({
  mode: z.enum(['create', 'edit']),
})

export const Route = createFileRoute('/organization_/$orgID/site')({
  component: Site,
  params: {
    parse: parseParams.parse,
  },
  validateSearch: searchParams,
  staticData: {
    title: 'Site',
    layout: {
      enableScrolling: true,
    },
  },
  beforeLoad: ({ search }) => {
    const { mode } = search
    const pathSegments = window.location.pathname.split('/').filter(Boolean)

    // Reject edit if this is exactly /organization/{orgId}/site
    if (mode === 'edit' && pathSegments.length === 3) {
      throw new Error(
        'Edit mode requires site ID. Use /organization/{orgId}/site/{siteId}?mode=edit'
      )
    }
  },
})
